module.exports = __webpack_public_path__ + "24e004ab/img/file-icon.c085e21e.svg";